import React, { useState, useEffect } from "react";
import { Typography, Grid, Container, Box } from "@mui/material";
import { CustomLabel } from "../../components/Custom/CustomTypography";
import api from "../../globals/axios";
import CustomAppBar from "../../components/AppBar";
import { makeStyles } from "@mui/styles";
import CustomButton from "../../components/Custom/CustomButton";
import { useTranslation } from "react-i18next";
import { lenderProfile } from "../../Data/fieldData";
import CustomTextField from "../../components/Custom/CustomTextField";
import LoaderContainer from "../../components/LoaderContainer";
import { useNavigate } from "react-router-dom";
import { useAlert } from "../../components/Alert";
import { getUserDetails } from "../../globals/authentication";
import ImageUpload from "../../components/Custom/ImagePlaceholder";
import { compressImage } from "../../globals/utils";

const useStyles = makeStyles(() => ({
  title: {
    fontSize: "30px !important",

    fontWeight: "700 !important",
    lineHeight: "18px",
  },
  value: {
    fontSize: "12px !important",
    color: "#827F7F",
    fontWeight: "400 !important",
    lineHeight: "18px",
  },
  fileText: {
    fontSize: "15px !important",
    // color: "#827F7F",
    fontWeight: "700 !important",
    lineHeight: "18px",
    marginTop: "8px",
  },
}));
export default function LenderProfile() {
  const classes = useStyles();
  const [formData, setFormData] = useState({});
  const { t } = useTranslation();
  const [loading, setLoading] = useState(true);
  const [docsRequired, setDocsRequired] = useState([]);
  const navigate = useNavigate();
  const { showAlert } = useAlert();
  const [lenderId, setLenderId] = useState("");
  const [isEdit, setIsEdit] = useState(false);
  let user = getUserDetails();

  const fetchDocsRequired = () => {
    api
      .get(`/lending/required-documents/`)
      .then((res) => {
        if (res && res.data) {
          setDocsRequired(res.data);
          setLoading(false);
        }
      })
      .catch((error) => {
        console.log("err", error);
      });
  };

  const fetchData = () => {
    api
      .get("lending/lender-onboard/")
      .then((res) => {
        if (res && res.data && res.data.length > 0) {
          const formDataCopy = { ...res.data[0] };
          setIsEdit(true);
          formDataCopy.required_documents = res.data[0].required_documents.map(
            (doc) => doc.id
          );
          setFormData(formDataCopy);
        }
      })
      .catch((error) => {
        console.log(error);
      });
  };
  useEffect(() => {
    fetchDocsRequired();
    if (user && user.app_user) {
      setLenderId(user.app_user.id);
    }
    fetchData();
  }, []);

  const handleChange = (name, value) => {
    setFormData((prevData) => ({ ...prevData, [name]: value }));
  };
  const handleFileUpload = async (file) => {
    try {
      const compressedImage = await compressImage(file);
      console.log("after compress image", compressedImage);
      setFormData({ ...formData, lender_logo: compressedImage });
    } catch (error) {
      console.error("Error compressing image:", error);
      showAlert("error", "Error compressing the image");
    }
  };

  const handleRemoveImage = () => {
    setFormData({ ...formData, lender_logo: null });
  };

  const handleCreate = () => {
    const updatedFormData = new FormData();
    updatedFormData.append("lender", lenderId);
    for (const key in formData) {
      if (formData[key] instanceof File) {
        updatedFormData.append(key, formData[key]);
      } else {
        const value =
          typeof formData[key] === "string"
            ? parseFloat(formData[key])
            : formData[key];
        updatedFormData.append(key, JSON.stringify(value));
      }
    }
    api
      .post("lending/lender-onboard/", updatedFormData)
      .then((res) => {
        if (res && res.data) {
          showAlert("success", "Create Successfully");
          navigate("/");
        } else {
          showAlert("error", "Error on creating Loan Details");
        }
      })
      .catch((err) => {
        console.error("Error creating lender profile:", err);
        showAlert("error", "Some error Occurred While Submitting the Data");
      });
  };
  console.log("isEid", isEdit);
  return (
    <>
      <CustomAppBar />
      <LoaderContainer loading={loading}>
        <Container
          maxWidth="xs"
          sx={{ mb: 3, marginTop: "20px", padding: "18px" }}
        >
          <div>
            <Grid container spacing={1} justify="center" direction="column">
              <Typography className={classes.title}>
                {t("Please Fill Details")}
              </Typography>

              <div style={{ marginTop: "20px" }}>
                <CustomLabel>{t("Loan Details :")}</CustomLabel>

                {lenderProfile.map((field) => (
                  <React.Fragment key={field.name}>
                    {field.type === "file" && (
                      <Box mt={2}>
                        <ImageUpload
                          onFileChange={handleFileUpload}
                          defaultImageUrl={formData && formData.lender_logo}
                          onRemove={handleRemoveImage}
                        />
                      </Box>
                    )}
                    {field.type === "range_values" && (
                      <CustomTextField
                        label={t(field.label)}
                        name={field.name}
                        name2={field.name2}
                        value={(formData && formData[field.name]) || ""}
                        value2={(formData && formData[field.name2]) || ""}
                        onChange={handleChange}
                        type={field.type}
                        title={field.title}
                      />
                    )}

                    {field.type === "number" && (
                      <CustomTextField
                        label={t(field.label)}
                        name={field.name}
                        value={(formData && formData[field.name]) || ""}
                        onChange={handleChange}
                        type={field.type}
                        title={field.title}
                      />
                    )}

                    {field.type === "checkboxes" &&
                      field.name === "required_documents" && (
                        <CustomTextField
                          label={t(field.label)}
                          name={field.name}
                          value={(formData && formData[field.name]) || ""}
                          onChange={handleChange}
                          type={field.type}
                          options={docsRequired.map((doc) => ({
                            value: doc.id,
                            label: doc.name,
                          }))}
                        />
                      )}
                  </React.Fragment>
                ))}
              </div>
              {!isEdit && (
                <CustomButton onClick={handleCreate}>{t("Save")}</CustomButton>
              )}
            </Grid>
          </div>
        </Container>
      </LoaderContainer>
    </>
  );
}
